<script setup lang="ts">
    type Link = {
        label: string
        url: string
    }

    const links: Link[] = [
        { label: 'Datenschutz', url: 'https://www.hs-anhalt.de/datenschutz.html' },
        { label: 'Impressum', url: 'https://www.hs-anhalt.de/impressum.html' }
    ]
</script>

<template>
    <v-footer
        class="d-flex align-center justify-center ga-5 flex-wrap flex-grow-1 py-2"
        color="primary-accent-1"
    >
        <v-btn
            v-for="link in links"
            :key="link.label"
            :text="link.label"
            :href="link.url"
            target="_blank"
            variant="text"
            rounded
        ></v-btn>
    </v-footer>
</template>
<style scoped>
    .v-footer {
        max-height: 12vh;
    }
</style>
